import React, { useEffect } from 'react';
import { trackGooglePageView } from '../../utility/common/GoogleTracking';
import ReactPixel from 'react-facebook-pixel';

const { REACT_APP_TRACKING_FACEBOOK, REACT_APP_TYPE } = process.env;
const testMode = (REACT_APP_TYPE !== 'production');

const advancedMatching = {  };
const options = {
  autoConfig: true,
  debug: testMode,
};
ReactPixel.init(REACT_APP_TRACKING_FACEBOOK, advancedMatching, options);

export default function Analytics(props){
  useEffect(() => {
    trackGooglePageView();
    if(!testMode){
      ReactPixel.pageView();
    } else {
      console.log(window.location.pathname + window.location.search);
    }
  }, []);

  return <></>;
}